import { initialKnmListState } from '../constants/initialKnmListState';
import { KnmListActionsEnum } from '../enums/KnmListActionsEnum';
import { IKnmListState } from '../interfaces/IKnmListState';
import { KnmListAction } from '../types/KnmListAction';

export function knmListReducer(state = initialKnmListState, action: KnmListAction) {
  switch (action.type) {
    case KnmListActionsEnum.KNM_LIST_SET_SEARCH_VALUE: {
      const newState: IKnmListState = {
        ...state,
        searchValue: action.payload.value,
      };

      return newState;
    }
    case KnmListActionsEnum.KNM_LIST_SET_DATA: {
      const { data, page, totalCount, pageCount, rejected } = action.payload;
      const newState: IKnmListState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
        rejected,
      };

      return newState;
    }
    case KnmListActionsEnum.KNM_LIST_SET_FIND_DATA: {
      const { findData } = action.payload;
      const newState: IKnmListState = {
        ...state,
        findData,
      };

      return newState;
    }
    case KnmListActionsEnum.KNM_LIST_SET_ORDER: {
      const { order } = action.payload;
      const newState: IKnmListState = {
        ...state,
        order,
      };

      return newState;
    }
    default:
      return state;
  }
}
